import { render, staticRenderFns } from "./SupportRequestDialog.vue?vue&type=template&id=95ffa566"
import script from "./SupportRequestDialog.vue?vue&type=script&lang=js"
export * from "./SupportRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports